import { useEffect, useState } from "react";
import CheckBox from "../CheckBox/CheckBox";
import "./TermsAndConditionsModal.scss";

interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
  loading?: boolean;
}

const TermsAndConditionsModal = ({
  isOpen,
  onAccept,
  onDecline,
  loading = false,
}: TermsAndConditionsModalProps) => {
  const [selection, setSelection] = useState<"accept" | "decline" | null>(null);

  useEffect(() => {
    if (isOpen) {
      setSelection(null);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const actionLabel =
    selection === "decline" ? "Decline and Logout" : "Accept and Continue";

  const handleSubmit = () => {
    if (selection === "accept") {
      onAccept();
      return;
    }

    if (selection === "decline") {
      onDecline();
    }
  };

  return (
    <div className="terms-modal-overlay" role="presentation">
      <div
        className="terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
      >
        <h2 id="terms-modal-title" className="terms-modal-title h4 border-bottom pb-3">
          Signing in
        </h2>
        <p className="terms-modal-copy">
          Please accept the <a className="terms-modal-link btn-text-link-uline" href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a> and the <a className="terms-modal-link btn-text-link-uline" href="https://www.heart.org/en/about-us/statements-and-policies/privacy-statement" target="_blank" rel="noopener noreferrer">Privacy Policy</a> to continue.
        </p>
        <div className="terms-modal-options">
          <CheckBox
            type="radio"
            name="termsAndConditions"
            id="terms-accept"
            className="form-group form-radio"
            labelText="Yes - I accept the terms of use and privacy policy."
            checked={selection === "accept"}
            onChange={() => setSelection("accept")}
          />
          <CheckBox
            type="radio"
            name="termsAndConditions"
            id="terms-decline"
            className="form-group form-radio"
            labelText="No - I do not accept the terms of use and privacy policy."
            checked={selection === "decline"}
            onChange={() => setSelection("decline")}
          />
        </div>
        <div className="terms-modal-actions">
          <button
            type="button"
            className="terms-modal-button btn btn-primary btn-round"
            onClick={handleSubmit}
            disabled={!selection || loading}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;